<template>
  <div class="w-full bg-white height-100">
    <div class="seth-set bg-primary px-6 py-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon class="flex" icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        My Request
      </h2>
    </div>

    <div class="flex w-full menucontrol-scroll fixed-top bg-white">
      <div class="heigh-tab p-8 w-full">
        <div class="grid grid-cols-2 gap-8 w-full pb-8">
          <div
            @click="handleClick(item)"
            class="flex items-start border rounded-10px cursor-pointer p-4"
            v-for="(item, index) in getrequest.data"
            :key="index"
          >
            <div class="w-9/12 flex items-center gap-2">
              <img
                :src="showImage(item.request.image)"
                class="object-contain wh-75px rounded-10px p-3 bg-cas"
                alt="banh"
              />

              <div class="pl-4">
                <h2 class="col-4f text-xl mb-0 font-semibold">
                  {{ item.request.name }}
                </h2>
                <p
                  class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                >
                  {{ getDate(item.createdAt) }}
                </p>
                <!-- <p class="font-mediu fsize12 text-8f8f8f flex items-center">
                      QTY: {{ item.quantity }}
                    </p> -->
              </div>
            </div>
            <div class="w-3/12">
              <div class="flex justify-end">
                <p
                  class="bg-light-orange fsize10 flex justify-center border-round py-1 px-4"
                >
                  {{ item.status }}
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="flex cursor-pointer w-full items-start">
                <div class="w-9/12 flex gap-2 items-center">
                  <div>
                    <img
                      src="@/assets/images/side.png"
                      class="object-cover w-24 h-24 border-round"
                      alt="side"
                    />
                  </div>
                  <div class="pl-4">
                    <h2 class="text-dark fsize16 mb-1 font-semibold">
                      Business Cards
                    </h2>
                    <p class="font-mediu fsize12 text-8f8f8f flex items-center">
                      Get a professinal buissness card design to impress your
                      connections.
                    </p>
                  </div>
                </div>
                <div class="w-3/12">
                  <div class="flex justify-end">
                    <p
                      class="bg-light-orange fsize10 flex justify-center border-round py-1 px-4"
                    >
                      Ongoing
                    </p>
                  </div>
                </div>
              </div> -->
          <!-- <div class="flex cursor-pointer w-full items-start">
                <div class="w-9/12 flex gap-2 items-center">
                  <div>
                    <img
                      src="@/assets/images/side.png"
                      class="object-cover w-24 h-24 border-round"
                      alt="banh"
                    />
                  </div>
                  <div class="pl-4">
                    <h2 class="text-dark fsize16 mb-1 font-semibold">
                      Business Cards
                    </h2>
                    <p class="font-mediu fsize12 text-8f8f8f flex items-center">
                      Get a professinal buissness card design to impress your
                      connections.
                    </p>
                  </div>
                </div>
                <div class="w-3/12">
                  <div class="flex justify-end">
                    <p
                      class="bg-light-green fsize10 flex justify-center border-round py-1 px-4"
                    >
                      Delivered
                    </p>
                  </div>
                </div>
              </div>
              <div class="flex cursor-pointer w-full items-start">
                <div class="w-9/12 flex gap-2 items-center">
                  <div>
                    <img
                      src="@/assets/images/side.png"
                      class="object-cover w-24 h-24 border-round"
                      alt="side"
                    />
                  </div>
                  <div class="pl-4">
                    <h2 class="text-dark fsize16 mb-1 font-semibold">
                      Business Cards
                    </h2>
                    <p class="font-mediu fsize12 text-8f8f8f flex items-center">
                      Get a professinal buissness card design to impress your
                      connections.
                    </p>
                  </div>
                </div>
                <div class="w-3/12">
                  <div class="flex justify-end">
                    <p
                      class="bg-light-orange fsize10 flex justify-center border-round py-1 px-4"
                    >
                      Ongoing
                    </p>
                  </div>
                </div>
              </div>

              <div class="flex cursor-pointer w-full items-start">
                <div class="w-9/12 flex gap-2 items-center">
                  <div>
                    <img
                      src="@/assets/images/side.png"
                      class="object-cover w-24 h-24 border-round"
                      alt="side"
                    />
                  </div>
                  <div class="pl-4">
                    <h2 class="text-dark fsize16 mb-1 font-semibold">
                      Business Cards
                    </h2>
                    <p class="font-mediu fsize12 text-8f8f8f flex items-center">
                      Get a professinal buissness card design to impress your
                      connections.
                    </p>
                  </div>
                </div>
                <div class="w-3/12">
                  <div class="flex justify-end">
                    <p
                      class="bg-light-orange fsize10 flex justify-center border-round py-1 px-4"
                    >
                      Ongoing
                    </p>
                  </div>
                </div>
              </div> -->
        </div>
      </div>
    </div>
    <el-pagination
      background
      @current-change="
        (value) => {
          currentPage = value;
          getRequests();
        }
      "
      layout="prev,pager,next"
      :per-size="10"
      :total="pageCount"
    ></el-pagination>
  </div>
</template>

<script>
import Plans2 from "@/views/adminPanel/pages/ecommerce/components/Plans2";
import { mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      pageCount: 0,
      currentPage: 1,
    };
  },
  components: {
    Plans2,
  },
  methods: {
    handleClick(item) {
      console.log(item, "request");
      Object.assign(item, { previousRoute: "studio-Myrequest" });
      this.$store.commit("studio/SELECTED_REQUEST", item);
      this.$store.commit("studio/PREVIOUS_ROUTE", "studio-Myrequest");
      this.$router.push({ name: "studio-chat" });
    },

    showImage(value) {
      let default_image = require("@/assets/images/card1.png");

      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    async getRequests() {
      let offset = 0;
      let getReq = await this.$store.dispatch("studio/getRequest", {
        projectName: this.selectedProject.projectName,
        projectId: this.selectedProject._id,
        // requestId: this.createrequest._id,
        status: ["Ongoing"],
        paginated: true,
        offset: 10 * this.currentPage - 10,
        createdAt: true,
      });
      console.log(getReq.data.data, "request");
      this.pageCount = getReq.data.count;
    },
  },
  computed: {
    ...mapState("studio", ["getrequest"]),
    ...mapState("user", ["selectedProject"]),
  },
  mounted() {
    this.getRequests();
  },
};
</script>
